// extracted by mini-css-extract-plugin
export default {"modalHeader":"styles_modalHeader__kbVcd","closeButton":"styles_closeButton__RBeZz","modalBody":"styles_modalBody__i3T5L","tableWrapper":"styles_tableWrapper__el2IW"};